<template lang="pug">
//v-container(:fluid="$vuetify.breakpoint.lgAndDown")
v-content
  v-toolbar.page-header(app, flat, fixed, color='white', height='105')
    v-breadcrumbs.ml-0(divider='/')
      v-breadcrumbs-item
        router-link(to='/opportunities')
          h2 Invention Opportunities
      v-breadcrumbs-item
        h2.ma-0(v-if='C.view.type.add')
          | Add Opportunity
        h2.ma-0(v-if='C.view.type.edit')
          | Edit Opportunity


  v-container.pa-0(fluid, grid-list-lg)
    v-layout(row, nowrap)
      v-flex.pr-4
        template
          v-form.form--edit(v-model='C.form.validation.overall', ref='form', lazy-validation)
            .section__title
              .subheading
                | Opportunity Info
            v-layout(row)
              v-flex(md3)
                v-subheader.pl-0
                  | Opportunity Title
              v-flex(md6)
                v-text-field.input--box(v-model='C.form.selected.invention_opportunity.title', :rules='C.form.validation.rules.invention_opportunity.title', single-line, :maxlength='255', required)

            v-layout(row)
              v-flex(md3)
                v-subheader.pl-0 Opportunity Description
              v-flex(md6)
                v-text-field.input--box(v-model='C.form.selected.invention_opportunity.short_description', multi-line, :rules='C.form.validation.rules.invention_opportunity.short_description', required)

            v-layout(row)
              v-flex(md3)
                v-subheader.pl-0 Expires
              v-flex(md6)
                v-menu.d-block
                  v-text-field.input--box(v-model='C.form.selected.invention_opportunity.closing_date', slot='activator', append-icon='event', readonly, single-line, required)
                  v-date-picker.input--box(v-model='C.form.selected.invention_opportunity.closing_date', no-title, actions)

            v-layout(row)
              v-flex(md3)
                v-subheader.pl-0 Status
              v-flex(md6)
                v-select.input--box(v-model='C.form.selected.invention_opportunity.status', label='Status', v-bind:items='C.form.list.status', item-text='label', item-value='value', single-line, required)

            v-layout(row, v-if='C.view.type.add && C.form.list.organizations.length > 1')
              v-flex(md3)
                v-subheader.pl-0 Organization
              v-flex(md6)
                v-select.input--box(v-model='C.form.selected.organization_id', v-bind:items='C.form.list.organizations', item-text='name', item-value='id', single-line, required)

            v-layout(row)
              v-flex(md3, v-if='!(C.view.type.edit && C.data.opportunity.uploaded_filename)')
                v-subheader.pl-0 Upload PDF or Word Document
              v-flex(md4, v-if='(C.view.type.edit && C.data.opportunity.uploaded_filename) && !C.form.selected.upload')
                v-subheader.pl-0
                  | Uploaded Opportunity: {{ C.data.opportunity.uploaded_filename }}
                v-subheader.pl-0
                  | Replace file (upload PDF or Word Document)
              v-flex(md6)
                input(@change='C.form.trigger.fileUpload', type="file")

            v-layout(row)
              v-flex(md3)
                v-subheader.pl-0 Presentation Template
              v-flex(md6)
                v-select.input--box(v-model='C.form.selected.invention_opportunity.presentation_template', v-bind:items='C.form.list.presentation_templates', item-text='label', item-value='value', single-line, required)

        v-layout(row)
          v-flex(md3)
          v-flex(md6)
            v-btn.ml-0(@click='C.form.trigger.submit', :disabled='!C.form.validation.overall || (C.view.type.add && !C.form.selected.organization_id) || !(C.view.type.edit || (C.view.type.add && C.form.selected.upload))', color='primary')
              | Save
            v-btn(:to='{name: "Opportunities"}')
              | Cancel

      v-flex(style='position: relative; flex: 0 0 236px')
        .d-block(style='width: 220px; position: fixed')
          v-card
            v-card-title
              | Some helpful tips on creating an attractive Invention Opportunity.
</template>

<script>
  import tools from '../../assets/tools.js'
  import axios from '../../../node_modules/axios/dist/axios.js'
  import moment from 'moment'

  export default {
    data () {
      return {
        C: {
          view: {
            id: null,
            type: {}
          },
          data: {
            opportunity: {}
          },
          form: {
            validation: {
              overall: false,
              rules: {
                invention_opportunity: {
                  title: [
                    (v) => !!v || 'Name is required',
                    (v) => v.length < 255 || 'You have reached the maximum limit of 255 characters.'
                  ],
                  short_description: [
                    (v) => !!v || 'Description is required'
                  ]
                }
              }
            },
            selected: {
              invention_opportunity: {
                title: '',
                short_description: '',
                status: 'Active',
                closing_date: moment().format('YYYY-MM-DD'),
                presentation_template: 'xinova'
              },
              organization_id: null,
              upload: null
            },
            list: {
              status: [{
                label: 'Active',
                value: 'Active'
              }, {
                label: 'Inactive',
                value: 'Inactive'
              }],
              presentation_templates: [{
                label: 'Xinova',
                value: 'xinova'
              }],
              organizations: []
            },
            trigger: {
              fileUpload: ($event) => {
                var component = this

                var $files = $event.target.files || $event.dataTransfer.files

                if (!$files.length) {
                  return
                }

                var targetFile = $files[0]

                component.C.form.selected.upload = targetFile
              },
              submit: () => {
                var component = this
                var apiCallPromise = null

                var submitBlob = new FormData()
                submitBlob.append('invention_opportunity[title]', component.C.form.selected.invention_opportunity.title)
                submitBlob.append('invention_opportunity[closing_date]', moment(component.C.form.selected.invention_opportunity.closing_date, 'YYYY-MM-DD').unix())
                submitBlob.append('invention_opportunity[short_description]', component.C.form.selected.invention_opportunity.short_description)
                submitBlob.append('invention_opportunity[status]', component.C.form.selected.invention_opportunity.status)

                if (component.C.form.selected.upload) {
                  submitBlob.append('upload', component.C.form.selected.upload)
                }

                if (component.C.view.type.add) {
                  submitBlob.append('organization_id', component.C.form.selected.organization_id)

                  apiCallPromise = axios.post(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/invention_opportunities/create`, submitBlob)
                } else if (component.C.view.type.edit) {
                  submitBlob.append('invention_opportunity_id', component.C.view.id)

                  apiCallPromise = axios.put(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/invention_opportunities/update`, submitBlob)
                }

                if (apiCallPromise) {
                  apiCallPromise
                    .then(function (response) {
                      console.info('Manage Opportunity Results: ', response.data)

                      component.$router.push({
                        name: 'Opportunities'
                      })

                      tools.alert({
                        type: 'success',
                        message: `${component.C.form.selected.invention_opportunity.title} has been saved.`
                      })
                    })
                    .catch(function (errorResponse) {
                      tools.alert({
                        type: 'error',
                        errorResponse: errorResponse
                      })
                    })
                }
              },
              refreshBaseData: () => {
                var component = this

                axios.get(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/invention_opportunities/detail`, {
                  params: {
                    invention_opportunity_id: component.C.view.id
                  }
                })
                     .then(response => {
                       var opportunityData = (response && response.data && response.data.data && response.data.data.invention_opportunity) || {}

                       component.C.data.opportunity = opportunityData

                       component.C.form.selected.invention_opportunity = {
                         title: opportunityData.title,
                         short_description: opportunityData.short_description,
                         closing_date: moment.unix(opportunityData.closing_time).format('YYYY-MM-DD'),
                         status: opportunityData.status,
                         presentation_template: 'xinova'
                       }
                     })
                     .catch(function (errorResponse) {
                       tools.alert({
                         type: 'error',
                         errorResponse: errorResponse
                       })
                     })
              }
            }
          }
        }
      }
    },
    created () {
      var component = this

      if (this.$route.params.id) {
        component.C.view.type.edit = true
        component.C.view.id = this.$route.params.id

        component.C.form.trigger.refreshBaseData()
      } else {
        component.C.view.type.add = true

        tools.getOrganizationsList({
          success: function (organizationList) {
            component.C.form.list.organizations = organizationList

            if (component.C.form.list.organizations.length === 1) {
              component.C.form.selected.organization_id = component.C.form.list.organizations[0].id
            }
          }
        })
      }
    }
  }
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Opportunities/Add.vue